import RenderField from '@app/components/Layout/Shares/FormHelpers/TextField';
import validate from './validate';
import { ScField, ScModalFinalForm } from '@app/components/Base/ScFinalForm';

// Cập nhật sỉ số
const ChangeQuantityModal = ({ isShow, onClose, onSubmit }) => (
    <ScModalFinalForm
        open={isShow}
        validate={validate}
        onSubmit={onSubmit}
        onClose={onClose}
        title="Cập nhật sỉ số"
        width={400}
    >
        <div className="row">
            <div className="col-md-12">
                <div className="form-group">
                    <ScField
                        name="quantity"
                        component={RenderField}
                        type="number"
                        className="form-control"
                        label="Số lượng tăng/giảm"
                    />
                </div>
            </div>
        </div>
    </ScModalFinalForm>
);

export default ChangeQuantityModal;
